import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Task } from '../../../../types/task.interface';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CamundaService } from '../../../../service/camunda.service';
import { Store } from '@ngrx/store';
import { FluxBPMState } from '../../../../store/reducer/flux-bpm.reducers';
import { AbstractTemplateComponent } from '../../abstract/abstract-template.component';
import { Subject } from 'rxjs';
import { Form } from '@flux/flux-core';
import {  FluxDynamicFormsModule } from '@flux/flux-dynamic-forms';
import { getVariableValue } from '../../../../util/variable-service';
import { first } from 'rxjs/operators';
import { untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { TranslatePipe } from '@ngx-translate/core';
import { ImageComponent } from '../../image-component/image.component';
import { SensorComponent } from '../../sensor-component/sensor.component';
import { CurrentFormService } from './service/current-form.service';
import { FormsService } from './service/forms.service';
import { NgForOf, NgIf } from '@angular/common';


@Component({
    selector: 'lib-flux-form-step-template',
    templateUrl: './form-template.component.html',
    styleUrls: ['./form-template.component.scss'],
  imports: [FluxDynamicFormsModule, ReactiveFormsModule, TranslatePipe, ImageComponent, SensorComponent, NgIf, NgForOf],
  providers: [CurrentFormService],
    standalone: true
})
export class FormTemplateComponent extends AbstractTemplateComponent implements OnInit {
    currentTask: Task;

    formGroup: UntypedFormGroup;

    public onFormSubmitted$: Subject<any> = new Subject();

    controlsArray = [];

    layoutForm: Form;

    dataObject = {} as any;

    prefix: string;

    newObjectCondition = true;

    constructor(
        protected camundaService: CamundaService,
        protected store: Store<FluxBPMState>,
        private formBuilder: UntypedFormBuilder,
        private currentForm: CurrentFormService
    ) {
        super(camundaService, store);
    }

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({});
        const formKey = getVariableValue(this.currentTask, 'formkey', null);
        this.prefix = getVariableValue(this.currentTask, 'prefix', '');
        this.currentForm
            .initByFormKey(formKey)
            .pipe(untilComponentDestroyed(this))
            .subscribe((form: Form) => {
                this.layoutForm = form;
            });
        this.config.showNextButton = false;
        this.config.showCancelButton = true;

        super.onInit(true);
    }

  save(): void {
    if (this.formGroup.valid) {
      const userMap = new Map(
        Object.entries(this.dataObject).map(([key, value]) => [
          this.normalizeKey(`${this.prefix}_${key}`),
          this.serializeValue(value)
        ])
      );
      this.finishTask('result', null, Object.fromEntries(userMap));
    } else {
      Object.keys(this.formGroup.controls).forEach(controlName => {
        this.formGroup.controls[controlName].markAsTouched();
      });
    }
  }

  private serializeValue(value: any): string {
    // Null oder undefined
    if (value === null || value === undefined) {
      return String(value);
    }

    // Arrays und Objekte -> JSON
    if (typeof value === 'object') {
      return JSON.stringify(value);
    }

    // Boolean, Number, String -> direkt konvertieren
    return String(value);
  }

  private normalizeKey(key: string): string {
    return key
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .replace(/\s+/g, '_')  // Ersetzt Leerzeichen durch Unterstriche
    .replace(/[^a-z0-9_]/g, ''); // Entfernt alle anderen Sonderzeichen
  }

    nextTriggered(): void {}

    taskUpdated(): void {}
}
